<template>
  <pt-gene-report-order class="pt-gene-report-order__withData"></pt-gene-report-order>
</template>

<script>
import PtGeneReportOrder from './index'
export default {
  name: 'pt-gene-report-order__withData',
  components: {
    'pt-gene-report-order': PtGeneReportOrder
  }
}
</script>
